import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import { FormattedMessage } from '../Intl';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

import './ValueProps.less';

const CNAME = 'ValueProps';

class ValueProps extends Component {
  componentDidMount() {
    const newValuePropsExp = AbacusClientUtils.evaluateExperiment('HA_PTA_HP_NewValueProps');
    if (newValuePropsExp.value === 0) {
      AbacusClientUtils.logExperiment(newValuePropsExp);
    }
  }

  render() {
    const ValuePropsItem = ({ title, blurb }) => (
      <li className={`${CNAME}__item`}>
        <strong className={`${CNAME}__title`}>{title}</strong>
        <span className={`${CNAME}__blurb`} dangerouslySetInnerHTML={{ __html: blurb }} />
      </li>
    );

    return (
      <div className={cnames(CNAME, 'hidden-xs')}>
        <ul className={`${CNAME}__list`}>
          <FormattedMessage id={['home.sellingpoints.1.title', 'home.sellingpoints.1.blurb']}>
            {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
          </FormattedMessage>
          <FormattedMessage id={['home.sellingpoints.2.title', 'home.sellingpoints.2.blurb']}>
            {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
          </FormattedMessage>
          <FormattedMessage id={['home.sellingpoints.3.title', 'home.sellingpoints.3.blurb']}>
            {(title, blurb) => (<ValuePropsItem {...{ title, blurb }} />)}
          </FormattedMessage>
        </ul>
      </div>
    );
  }
}

ValueProps.propTypes = {
  title: PropTypes.string,
  blurb: PropTypes.string
};

export default ValueProps;



// WEBPACK FOOTER //
// ./src/universal/components/ValueProps/ValueProps.js